const FilterTypes = {
  INPUT: 0,
  SELECT: 1,
  AUTOCOMPLETE: 2,
  RANGE: 3,
  DATEPICKER: 4,
  DATERANGE: 5,
};

export {
  FilterTypes, // eslint-disable-line import/prefer-default-export
};
